import { camelCaseToRegularCase } from "helpers/camelCaseToRegularCase";

export const getOtherDetails = (agent: any) => {
    switch (agent) {
        case "orderProcessing":
            return {
                name: "Email Order Processing",
                text: "Turns messy email orders into clean data automatically.",
                img: "https://storage.googleapis.com/heysynth_files/synth_webapp/Frame%202085661197%20(7).svg",
                icons: [
                    "https://storage.googleapis.com/heysynth_files/synth_webapp/gmail_1_zya4ai.svg",
                    "https://storage.googleapis.com/heysynth_files/synth_webapp/ms_outlook_iqonc9.svg",
                ],
                active: true,
                color: "#6562E5",
            };
        case "marketingCampaign":
            return {
                name: "Marketing Campaign",
                text: "Syncs promotions with real-time inventory levels.",
                icons: [
                    "https://storage.googleapis.com/heysynth_files/synth_webapp/Klaviyo_symbol_zynlc7.webp",
                    "https://storage.googleapis.com/heysynth_files/synth_webapp/tiktok_logo.webp",
                    "https://storage.googleapis.com/heysynth_files/synth_webapp/google-ads_syiiti.svg",
                ],
                img: "https://storage.googleapis.com/heysynth_files/synth_webapp/Frame%202085661197%20(8).svg",
                color: "#EA580C",
            };
        case "EDIAssistant":
            return {
                name: "EDI Assistant",
                text: "Automates EDI document processing workflows.",
                icons: [
                    "https://storage.googleapis.com/heysynth_files/synth_webapp/sps_commerce_v0uhiz.png",
                ],
                img: "https://storage.googleapis.com/heysynth_files/synth_webapp/Frame%202085661197%20(9).svg",
                color: "#00C6FA",
            };
        case "InventoryManagement":
            return {
                name: "Inventory Report Agent",
                text: "Automatically updates inventory reports from 3PLs, warehouses, and manufacturers.",
                img: "https://storage.googleapis.com/heysynth_files/synth_webapp/Frame%202085661197%20(15).svg",
                color: "#B9017A",
            };
        case "TargetAlly":
            return {
                name: "Target Ally",
                text: "Set and track sales target and performance using natural language prompts",
                img: "https://storage.googleapis.com/heysynth_files/synth_webapp/Frame%202085661197%20(13).svg",
                color: "#56B648",
                canTurnOffAgent: true,
            };
        case "NewProductForecaster":
            return {
                name: "New Product Forecaster",
                text: "Generate forecasts for new product launches using existing product and channel data",
                img: "https://storage.googleapis.com/heysynth_files/synth_webapp/Frame%202085661197%20(14).svg",
                color: "#0054C2",
                canTurnOffAgent: true,
            };
        case "stockSense":
            return {
                name: "StockSense",
                text: "Tracks, forecasts and automates store-level inventory workflows.",
                img: "https://storage.googleapis.com/heysynth_files/synth_webapp/Frame%202085661197%20(10).svg",
                color: "#FFB902",
            };
        case "custom":
            return {
                name: "Request Custom AI Agent",
                text: "Can't find what you need? We'll create a custom agent that fits your requirements.",
                status: "custom",
                img: "https://storage.googleapis.com/heysynth_files/synth_webapp/Frame%202085661197%20(11).svg",
                // color: "#FFB902",
            };
        default:
            return {
                name: camelCaseToRegularCase(agent),
                text: "",
                status: "",
                img: "https://storage.googleapis.com/heysynth_files/synth_webapp/Frame%202085661197%20(9).svg",
            };
    }
};
